import { Image } from 'expo-image'
import { Linking, View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { Card, CardBody, CardFooter, CardHeader } from '@/src/elements/card'
import { Typography } from '@/src/elements/text/Typography'
import { TEST_ID } from '@/src/general/constants/testId'
import { useTranslate } from '@/src/lang/useTranslate'

const ROSARIO_LANDING_URL = 'https://qrco.de/bdWZIh'
export const RosarioBloc = () => {
  const { t } = useTranslate()

  return (
    <Card testID={TEST_ID.ELEMENT.ROSARIO_BLOC} className="bg-primary-bg-light px-1 py-3">
      <CardHeader className="mx-auto max-w-80">
        <Typography black center colors="primary" size="lg">
          {t('rosario.bloc.title')}
        </Typography>
      </CardHeader>

      <CardBody className="flex-1 flex-row flex-wrap items-center gap-6">
        <View className="w-full sm:flex-1" style={{ aspectRatio: 300 / 270 }}>
          <Image
            style={{ aspectRatio: 300 / 270 }}
            source={require('@/assets/img/rosario-bloc.png')}
            className="h-full w-full rounded-xl"
            contentFit="contain"
          />
        </View>

        <View className="w-full gap-2 sm:flex-1">
          <Typography colors="primary">{t('rosario.bloc.description.1')}</Typography>
          <Typography colors="primary">{t('rosario.bloc.description.2')}</Typography>
          <Typography colors="primary">{t('rosario.bloc.description.3')}</Typography>
        </View>
      </CardBody>

      <CardFooter>
        <Button colors="primary" variant="solid" onPress={() => Linking.openURL(ROSARIO_LANDING_URL)}>
          {t('rosario.bloc.cta')}
        </Button>
      </CardFooter>
    </Card>
  )
}
